import React from 'react';
import {Link} from 'react-router-dom'

export class WrapperHoc extends React.Component{
    render(){
        return (
            <div className="wrapperhoc">
                <section className="hero is-fullheight">
                    <div className="hero-head">
                    </div>
                    <div className="hero-body">
                        <div className="container">
                            <div className="column is-5 is-offset-3">
                            <Link to ="/">
                                <img src="/images/logo-dark.png" className="m-b-lg"/>
                            </Link>

                                {this.props.children}
                            </div>
                        </div>
                    </div>
                    <div className="hero-foot Footer">
                        <div className="container">
                            <div className="content has-text-centered">
                                © Copyright 2019 HWG Cash
                            </div>
                        </div>
                    </div>
                </section>

            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/_components/WrapperHoc.jsx